/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserTaskStatus } from './UserTaskStatus';
import {
    UserTaskStatusFromJSON,
    UserTaskStatusFromJSONTyped,
    UserTaskStatusToJSON,
    UserTaskStatusToJSONTyped,
} from './UserTaskStatus';

/**
 * 
 * @export
 * @interface ToDoTaskRow
 */
export interface ToDoTaskRow {
    /**
     * 
     * @type {string}
     * @memberof ToDoTaskRow
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ToDoTaskRow
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ToDoTaskRow
     */
    description: string | null;
    /**
     * 
     * @type {UserTaskStatus}
     * @memberof ToDoTaskRow
     */
    status: UserTaskStatus;
    /**
     * 
     * @type {Date}
     * @memberof ToDoTaskRow
     */
    dueAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ToDoTaskRow
     */
    sourceModule: string | null;
    /**
     * 
     * @type {string}
     * @memberof ToDoTaskRow
     */
    sourceReference: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ToDoTaskRow
     */
    createdAt: Date;
}



/**
 * Check if a given object implements the ToDoTaskRow interface.
 */
export function instanceOfToDoTaskRow(value: object): value is ToDoTaskRow {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('dueAt' in value) || value['dueAt'] === undefined) return false;
    if (!('sourceModule' in value) || value['sourceModule'] === undefined) return false;
    if (!('sourceReference' in value) || value['sourceReference'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ToDoTaskRowFromJSON(json: any): ToDoTaskRow {
    return ToDoTaskRowFromJSONTyped(json, false);
}

export function ToDoTaskRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToDoTaskRow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'description': json['description'],
        'status': UserTaskStatusFromJSON(json['status']),
        'dueAt': (json['dueAt'] == null ? null : new Date(json['dueAt'])),
        'sourceModule': json['sourceModule'],
        'sourceReference': json['sourceReference'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ToDoTaskRowToJSON(json: any): ToDoTaskRow {
    return ToDoTaskRowToJSONTyped(json, false);
}

export function ToDoTaskRowToJSONTyped(value?: ToDoTaskRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'status': UserTaskStatusToJSON(value['status']),
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
        'sourceModule': value['sourceModule'],
        'sourceReference': value['sourceReference'],
        'createdAt': value['createdAt'].toISOString(),
    };
}

